// ABOUTME: Review API client for internal reviewer auth and application management
// ABOUTME: Stub implementation returns fake data; swap fetch calls when backend is ready

const STUB_DELAY_MS = 600;

const STUB_APPLICATIONS = [
  {
    id: '1', submissionId: 'APP-2026-1', applicantName: 'Maria Santos', applicantEmail: 'maria@example.com', applicantAge: 28, city: 'Austin', status: 'Pending', createdAt: '2026-03-15T10:30:00Z',
    passionResponse: 'I am passionate about community gardening and teaching children about sustainable food systems. Nothing brings me more joy than watching a seed I planted grow into something that feeds my neighbors.',
    journeyResponse: 'I grew up in a small town in Texas where my grandmother taught me everything about plants. After college I moved to Austin and started a community garden in my neighborhood that now feeds over 40 families.',
    voiceNoteText: null, mediaAttachments: [], voiceNote: null, internalNotes: '', decisionReason: ''
  },
  {
    id: '2', submissionId: 'APP-2026-2', applicantName: 'James Chen', applicantEmail: 'james.chen@example.com', applicantAge: 34, city: 'Austin', status: 'In Review', createdAt: '2026-03-16T14:20:00Z',
    passionResponse: 'Music production and sound design. I spend every free moment creating beats and experimenting with synthesizers.',
    journeyResponse: 'Started making beats in my bedroom at 16. Now I run a small studio in East Austin where I help local artists record their first tracks for free.',
    voiceNoteText: 'Hey, I just wanted to say I am really excited about this opportunity. Music has saved my life and I want to share that with others.', mediaAttachments: ['https://example.com/james-studio.jpg'], voiceNote: null, internalNotes: 'Strong candidate, good community involvement', decisionReason: ''
  },
  {
    id: '3', submissionId: 'APP-2026-3', applicantName: 'Aisha Johnson', applicantEmail: 'aisha.j@example.com', applicantAge: 22, city: 'New York', status: 'Pending', createdAt: '2026-03-17T09:15:00Z',
    passionResponse: 'Spoken word poetry and storytelling. I believe everyone has a story worth telling.',
    journeyResponse: 'I started performing at open mics in Harlem when I was 17. Since then I have published two chapbooks and performed at over 50 venues across the city.',
    voiceNoteText: null, mediaAttachments: [], voiceNote: 'https://example.com/aisha-voice.webm', internalNotes: '', decisionReason: ''
  },
  {
    id: '4', submissionId: 'APP-2026-4', applicantName: 'Liam O\'Brien', applicantEmail: 'liam.ob@example.com', applicantAge: 31, city: 'New York', status: 'Accepted', createdAt: '2026-03-18T16:45:00Z',
    passionResponse: 'Documentary filmmaking focused on immigrant communities and their contributions to American culture.',
    journeyResponse: 'After film school I spent three years documenting stories in Queens. My short film "New Roots" screened at Tribeca and led to a grant for my next project.',
    voiceNoteText: null, mediaAttachments: ['https://example.com/liam-still-1.jpg', 'https://example.com/liam-still-2.jpg'], voiceNote: null, internalNotes: 'Incredible portfolio. Accepted unanimously.', decisionReason: 'Your documentary work is exactly the kind of authentic storytelling we want to support. Welcome to Homara.'
  },
  {
    id: '5', submissionId: 'APP-2026-5', applicantName: 'Sofia Reyes', applicantEmail: 'sofia.r@example.com', applicantAge: 26, city: 'Los Angeles', status: 'Pending', createdAt: '2026-03-19T11:00:00Z',
    passionResponse: 'Ceramics and pottery. There is something meditative about shaping clay with your hands.',
    journeyResponse: 'I learned pottery from my aunt in Oaxaca. Now I sell my work at farmers markets in LA and teach weekend workshops.',
    voiceNoteText: null, mediaAttachments: ['https://example.com/sofia-pottery.jpg'], voiceNote: null, internalNotes: '', decisionReason: ''
  },
  {
    id: '6', submissionId: 'APP-2026-6', applicantName: 'David Kim', applicantEmail: 'david.k@example.com', applicantAge: 29, city: 'Chicago', status: 'Rejected', createdAt: '2026-03-20T08:30:00Z',
    passionResponse: 'Graphic design and brand identity.',
    journeyResponse: 'Freelance designer for 5 years.',
    voiceNoteText: null, mediaAttachments: [], voiceNote: null, internalNotes: 'Application was very brief. Did not demonstrate community focus.', decisionReason: 'Thank you for applying. We were not able to move forward at this time but encourage you to reapply with more detail about your community involvement.'
  },
  {
    id: '7', submissionId: 'APP-2026-7', applicantName: 'Emma Wilson', applicantEmail: 'emma.w@example.com', applicantAge: 24, city: 'Seattle', status: 'Pending', createdAt: '2026-03-21T13:10:00Z',
    passionResponse: 'Urban sketching and watercolor painting. I love capturing the way light hits buildings at different times of day.',
    journeyResponse: 'I carry a sketchbook everywhere. Over the last two years I have filled 14 sketchbooks with drawings of Seattle neighborhoods. I run a monthly sketch walk where anyone can join.',
    voiceNoteText: null, mediaAttachments: ['https://example.com/emma-sketch-1.jpg', 'https://example.com/emma-sketch-2.jpg'], voiceNote: 'https://example.com/emma-voice.webm', internalNotes: '', decisionReason: ''
  },
  {
    id: '8', submissionId: 'APP-2026-8', applicantName: 'Carlos Mendez', applicantEmail: 'carlos.m@example.com', applicantAge: 27, city: 'Miami', status: 'In Review', createdAt: '2026-03-22T15:55:00Z',
    passionResponse: 'Street photography and zine making. I document the everyday beauty of Miami neighborhoods that tourists never see.',
    journeyResponse: 'Born and raised in Little Havana. I started a monthly zine called "305 Stories" that features local artists and business owners. We distribute 500 copies for free.',
    voiceNoteText: null, mediaAttachments: ['https://example.com/carlos-zine.jpg'], voiceNote: null, internalNotes: 'Great community project. Need to discuss in next review meeting.', decisionReason: ''
  },
  {
    id: '9', submissionId: 'APP-2026-9', applicantName: 'Yuki Tanaka', applicantEmail: 'yuki.t@example.com', applicantAge: 33, city: 'Portland', status: 'Pending', createdAt: '2026-03-23T10:05:00Z',
    passionResponse: 'Fermentation and food preservation. I find joy in the intersection of science, tradition, and flavor.',
    journeyResponse: 'I apprenticed with a miso maker in Japan for two years, then moved to Portland and started a small fermentation workshop. I teach classes on making koji, miso, and kimchi.',
    voiceNoteText: null, mediaAttachments: [], voiceNote: null, internalNotes: '', decisionReason: ''
  },
  {
    id: '10', submissionId: 'APP-2026-10', applicantName: 'Rachel Green', applicantEmail: 'rachel.g@example.com', applicantAge: 30, city: 'San Francisco', status: 'Pending', createdAt: '2026-03-24T12:40:00Z',
    passionResponse: 'Printmaking and risograph art. I love the tactile quality of ink on paper and the happy accidents that come with each print run.',
    journeyResponse: 'I run a small print studio in the Mission where I create art prints and collaborate with local writers on illustrated zines and broadsides.',
    voiceNoteText: null, mediaAttachments: ['https://example.com/rachel-print-1.jpg'], voiceNote: null, internalNotes: '', decisionReason: ''
  },
];

let reviewToken = null;

/**
 * Authenticate with the review session endpoint.
 * @param {string} password
 * @returns {Promise<{success: boolean, error?: string}>}
 */
export async function createReviewSession(password) {
  // TODO: Replace stub with POST /api/review/session
  await new Promise((r) => setTimeout(r, STUB_DELAY_MS));

  if (password === 'homaralovesyou') {
    reviewToken = 'stub-review-token';
    return { success: true };
  }
  return { success: false, error: 'incorrect password' };
}

/**
 * Fetch all applications for the reviewer.
 * @returns {Promise<{success: boolean, applications?: Array, error?: string}>}
 */
export async function fetchApplications() {
  // TODO: Replace stub with GET /api/review/applications (with reviewToken header)
  await new Promise((r) => setTimeout(r, STUB_DELAY_MS));

  if (!reviewToken) {
    return { success: false, error: 'not authenticated' };
  }

  return { success: true, applications: STUB_APPLICATIONS };
}

/**
 * Fetch a single application by ID.
 * @param {string} id
 * @returns {Promise<{success: boolean, application?: Object, error?: string}>}
 */
export async function fetchApplicationDetail(id) {
  // TODO: Replace stub with GET /api/review/applications/:id
  await new Promise((r) => setTimeout(r, STUB_DELAY_MS));

  if (!reviewToken) {
    return { success: false, error: 'not authenticated' };
  }

  const app = STUB_APPLICATIONS.find((a) => a.id === id);
  if (!app) {
    return { success: false, error: 'application not found' };
  }

  return { success: true, application: { ...app } };
}

/**
 * Update an application's status, notes, or decision reason.
 * @param {string} id
 * @param {Object} fields - { status?, internalNotes?, decisionReason? }
 * @returns {Promise<{success: boolean, application?: Object, error?: string}>}
 */
export async function updateApplication(id, fields) {
  // TODO: Replace stub with PATCH /api/review/applications/:id
  await new Promise((r) => setTimeout(r, STUB_DELAY_MS));

  if (!reviewToken) {
    return { success: false, error: 'not authenticated' };
  }

  const app = STUB_APPLICATIONS.find((a) => a.id === id);
  if (!app) {
    return { success: false, error: 'application not found' };
  }

  if (fields.status !== undefined) app.status = fields.status;
  if (fields.internalNotes !== undefined) app.internalNotes = fields.internalNotes;
  if (fields.decisionReason !== undefined) app.decisionReason = fields.decisionReason;

  return { success: true, application: { ...app } };
}

/**
 * Clear the stored review session.
 */
export function clearReviewSession() {
  reviewToken = null;
}

/**
 * Check if a review session is active.
 */
export function hasReviewSession() {
  return reviewToken !== null;
}

